import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { DeleteKonstanteCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [DeleteKonstanteCommandService],
  exports: []
})
export class DeleteKonstanteCommandServiceModule { }
